import { usePermissions } from '../hooks/usePermissions'
import { useMediaQuery } from '../hooks/useMediaQuery'

/**
 * Wrapper que decide qué versión de página mostrar según el rol del usuario
 * - DUEÑO y PET_SITTER: versión móvil
 * - VETERINARIO, ADMIN, SUPERADMIN: versión desktop
 */
export default function PageWrapper({ 
  MobileComponent, 
  DesktopComponent,
  useMobileForAllRoles = false,
  ...props 
}) {
  const { isDueno, isPetSitter } = usePermissions()
  const isMobileViewport = useMediaQuery('(max-width: 1023px)')
  const useMobile = isMobileViewport && (useMobileForAllRoles || isDueno || isPetSitter)

  if (useMobile && MobileComponent) {
    return <MobileComponent {...props} />
  }

  return <DesktopComponent {...props} />
}
